<template>
  <div>
    <div class="selectTypeBox">
      <el-radio-group v-model="selectType" @change="onChangeSelectType">
        <el-radio-button label="待审核"></el-radio-button>
        <el-radio-button label="审核成功"></el-radio-button>
        <el-radio-button label="审核失败"></el-radio-button>
        <el-radio-button label="终止合作"></el-radio-button>
        <el-radio-button label="未认证"></el-radio-button>
      </el-radio-group>
      <el-button
        type="primary"
        icon="el-icon-circle-plus-outline"
        class="addbtn"
        @click="addzw()"
        >添加主体公司</el-button
      >
    </div>
    <div style="width: 80%; margin: 15px auto 15px auto">
      <el-input
        placeholder="请输入公司名称进行搜索"
        v-model="companyName"
        class="input-with-select"
        @change="changeCompanyName"
      >
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
    </div>
    <div class="itemList">
      <div class="itemDiv" v-for="item in dataList" :key="item.id">
        <div class="logoBox">
          <img :src="item.companyLogo" />
        </div>
        <div class="companyInfoBox">
          <div>公司名称: {{ item.company }} ({{ item.companyName }})</div>
          <div>联系人名称: {{ item.linkman }}</div>
          <div>联系人电话: {{ item.linkmanPhone }}</div>
          <div>联系人邮箱: {{ item.companyEmail }}</div>
        </div>
        <div
          v-if="item.status !== 0"
          @click="showCompanyAudit(item)"
          class="companyAudit"
          v-bind:data-src="item.businessLicenseUrl"
        >
          <div class="imageAction">
            <img :src="item.businessLicenseUrl" />
          </div>
          <div class="textAction">
            统一社会信用保障码<br />{{ item.companyCode }}
          </div>
        </div>
        <div class="actionBox">
          <el-tooltip
            class="item"
            effect="dark"
            content="审核通过"
            placement="top-start"
          >
            <el-button
              v-if="item.status === 1 || item.status === 0"
              type="success"
              icon="el-icon-check"
              @click="setCompanyStatus(item, 2)"
              circle
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="审核失败"
            placement="top-start"
          >
            <el-button
              v-if="item.status === 1 || item.status === 0"
              type="danger"
              icon="el-icon-close"
              @click="setCompanyStatus(item, 3)"
              circle
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="合作结束"
            placement="top-start"
          >
            <el-button
              v-if="item.status === 2"
              type="info"
              icon="el-icon-minus"
              @click="setCompanyStatus(item, 4)"
              circle
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="重置密码"
            placement="top-start"
          >
            <el-button
              v-if="item.status === 2"
              type="warning"
              icon="el-icon-question"
              @click="czPassword(item)"
              circle
            ></el-button>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="imgShadow" v-if="ckMode">
      <div class="close" @click="hideCompanyAudit">
        <el-button icon="el-icon-close" circle></el-button>
      </div>
      <img :src="activeItem.businessLicenseUrl" />
      <div>
        <div class="textAction">
          统一社会信用保障码<br />{{ activeItem.companyCode }}
        </div>
        <div class="actionBox">
          <el-tooltip
            class="item"
            effect="dark"
            content="审核通过"
            placement="top-start"
          >
            <el-button
              v-if="activeItem.status === 1 || activeItem.status === 0"
              type="success"
              icon="el-icon-check"
              @click="setCompanyStatus(activeItem, 2)"
              circle
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="审核失败"
            placement="top-start"
          >
            <el-button
              v-if="activeItem.status === 1 || activeItem.status === 0"
              type="danger"
              icon="el-icon-close"
              @click="setCompanyStatus(activeItem, 3)"
              circle
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="合作结束"
            placement="top-start"
          >
            <el-button
              v-if="activeItem.status === 2"
              type="info"
              icon="el-icon-minus"
              @click="setCompanyStatus(activeItem, 4)"
              circle
            ></el-button>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="block">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="pageNumber"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="pageTotal"
      >
      </el-pagination>
    </div>
    <el-dialog :title="form2.title" :visible.sync="dialogFormVisible2">
      <el-form :model="form2">
        <el-form-item label="企业全称" :label-width="formLabelWidth">
          <el-input v-model="form2.customCompanyFullName"></el-input>
        </el-form-item>
        <el-form-item label="企业简称" :label-width="formLabelWidth">
          <el-input v-model="form2.customCompanyName"></el-input>
        </el-form-item>
        <el-form-item label="企业地址" :label-width="formLabelWidth">
          <el-select
            style="width: 400px"
            v-model="form2.detailedAddress"
            clearable
            filterable
            remote
            reserve-keyword
            placeholder="请输入地点进行搜索"
            :remote-method="getSearchSuggestion"
            :loading="searchloading"
            @clear="searchClear"
            @change="searchChange"
          >
            <el-option
              v-for="item in searchSuggestion"
              :key="item.id"
              :label="item.address + '(' + item.title + ')'"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="企业所在城市" :label-width="formLabelWidth">
          <el-input v-model="form2.inTheCity"></el-input>
        </el-form-item>
        <el-form-item label="企业官网" :label-width="formLabelWidth">
          <el-input v-model="form2.customCompanyWeb"></el-input>
        </el-form-item>
        <el-form-item label="企业性质" :label-width="formLabelWidth">
          <el-select
            v-model="form2.customCompanyNature"
            placeholder="请选择企业性质"
          >
            <el-option
              :label="item"
              v-for="(item, index) in NatureSelector"
              :key="index"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属行业" :label-width="formLabelWidth">
          <el-select v-model="form2.industry" placeholder="请选择所属行业">
            <el-option
              :label="item.value"
              v-for="(item, index) in industrySelector"
              :key="index"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="融资阶段" :label-width="formLabelWidth">
          <el-select
            v-model="form2.financingStage"
            placeholder="请选择融资阶段"
          >
            <el-option
              :label="item"
              v-for="(item, index) in financingStageSelector"
              :key="index"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="人员规模" :label-width="formLabelWidth">
          <el-select v-model="form2.staffSize" placeholder="请选择人员规模">
            <el-option
              :label="item"
              v-for="(item, index) in companyPeopleNumberSelector"
              :key="index"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司logo" :label-width="formLabelWidth">
          <el-upload
            :show-file-list="false"
            :key="setid"
            class="avatar-uploader"
            drag
            action="1"
            :on-change="setFile"
            :auto-upload="false"
            :limit="1"
            :on-remove="remove"
            ref="upload"
          >
            <img
              fit="cover"
              v-if="
                customCompanyLogo &&
                customCompanyLogo.indexOf('https://images.qilinpin.cn/') >= 0
              "
              :src="customCompanyLogo"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <my-cropper
            ref="myCropper"
            @getFile="getFile"
            @upAgain="upAgain"
          ></my-cropper>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button
          type="primary"
          @click="
            form2.title === '编辑客户公司信息' ? saveCompany() : addCompany()
          "
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
import OSS from 'ali-oss'
import qs from 'qs'
import MyCropper from './cropper.vue'

let client = new OSS({
  region: 'oss-cn-beijing',
  accessKeySecret: 'mPTRYqVIIWC8XxSeZqKFMPtFMWMfb5', // AccessKeySecret 去你的阿里云上控制台上找
  accessKeyId: 'LTAIvBaMapD5qPW9', // AccessKeyId 去你的阿里云上控制台上找
  bucket: 'linkedln',
  endpoint: 'images.qilinpin.cn',
  cname: true,
  secure: true,
})
// var qs = require('qs');
export default {
  name: 'companyAudit',
  props: {},
  components: { MyCropper },
  data() {
    return {
      companyName: '',
      pageSize: 20,
      pageNumber: 1,
      pageTotal: 0,
      dataList: [],
      setid: '',
      selectType: '待审核',
      ckMode: false,
      activeItem: false,
      selectTypeArray: {
        待审核: 1,
        审核成功: 2,
        审核失败: 3,
        终止合作: 4,
        未认证: 0,
      },
      NatureSelector: [
        '国有企业',
        '集体所有制企业',
        '私营企业',
        '股份制企业',
        '有限合伙企业',
        '联营企业',
        '外商投资企业',
        '个人独资企业',
      ],
      financingStageSelector: [
        '未融资',
        '种子轮',
        '天使轮',
        'A轮',
        'B轮',
        'C轮',
        'D轮及以上',
        '上市公司',
        '不需要融资',
      ],
      companyPeopleNumberSelector: [
        '50人以下',
        '50-59人',
        '100-499人',
        '500-999人',
        '1000-9999人',
        '10000人以上',
      ],
      form2: {
        title: '',
        companyId: '',
        userId: '',
        customCompanyFullName: '',
        customCompanyWeb: '',
        customCompanyName: '',
        detailedAddress: '',
        inTheCity: '',
        customCompanyNature: '',
        financingStage: '',
        staffSize: '',
        industry: '',
      },
      searchloading: false,
      industrySelector: [],
      customCompanyFullName: '',
      customCompanyWeb: '',
      customCompanyName: '',
      detailedAddress: '',
      inTheCity: '',
      title: '添加新的客户公司信息',
      file: false,
      customCompanyLogo: '',
      dialogFormVisible2: false,
    }
  },
  methods: {
    upAgain() {
      this.$refs.upload.clearFiles() //清空上传列表
      this.$refs['upload'].$refs['upload-inner'].handleClick()
    },

    getFile(file) {
      let that = this
      const formData = new FormData()
      formData.append('file', file)
      that.file = file
      that.uplaod()
    },
    random_string: function (len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    random_number: function (len) {
      len = len || 32
      var chars = '123456789'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    uplaod: function (res) {
      let that = this
      let str = this.random_string(32)
      client
        .multipartUpload('upload/' + str + '.png', this.file, {
          progress: function (p) {
            that.loading = true
            console.log('Progress: ' + p)
            that.p = p
          },
        })
        .then((res) => {
          debugger
          that.loading = false
          console.log(res)
          that.$refs.myCropper.close()
          that.customCompanyLogo = 'https://images.qilinpin.cn/' + res.name
        })
        .catch((err) => {
          debugger
          that.loading = false
          console.log(err)
        })
    },
    remove: function () {
      this.file = false
    },
    setFile: function (res) {
      debugger
      let that = this
      let file = res.raw
      this.$nextTick(() => {
        this.$refs.myCropper.open(file.raw || file)
      })
    },
    getHyList: function () {
      let that = this
      axios({
        method: 'GET',
        url: Config.path + '/api/common/dict/getDictlist?type=jobType',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
      })
        .then((res) => {
          if (res.data.success === '1') {
            that.industrySelector = res.data.content
            that.industry = res.data.content[0].value
            that.industryCode = res.data.content[0].code
          } else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    getIp: function () {
      let that = this

      this.$jsonp('https://apis.map.qq.com/ws/location/v1/ip', {
        key: 'HTEBZ-R2RWW-32VR6-RZGNC-TV5M5-LPBNI',
        ip: '220.249.55.194',
        output: 'jsonp',
      })
        .then((res) => {
          if (res.status === 0) {
            this.seacherregion = res.result.ad_info.city
          } else {
            this.seacherregion = '北京市'
          }
        })
        .catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },

    getSearchSuggestion: function (e) {
      let that = this
      that.searchloading = true

      this.$jsonp('https://apis.map.qq.com/ws/place/v1/suggestion', {
        keyword: e,
        region: this.seacherregion,
        region_fix: 0,
        key: 'HTEBZ-R2RWW-32VR6-RZGNC-TV5M5-LPBNI',
        output: 'jsonp',
      })
        .then((res) => {
          that.searchloading = false
          if (res.status === 0) {
            for (let i in res.data) {
              res.data[i].value =
                res.data[i].address + '(' + res.data[i].title + ')'
              res.data[i].label =
                res.data[i].address + '(' + res.data[i].title + ')'
            }
            that.searchSuggestion = res.data
          }
        })
        .catch((err) => {
          that.searchloading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },

    searchClear: function () {
      this.searchaddres = ''
      this.searchloading = false
      this.searchSuggestion = []
    },

    searchChange: function (e) {
      this.form2.inTheCity = e.city
    },
    addCompany: function () {
      let that = this
      if (
        this.form2.customCompanyFullName === '' ||
        this.form2.customCompanyFullName === undefined
      ) {
        that.$message.error('请输入您公司的名称')
        return false
      }
      if (
        this.form2.customCompanyWeb === '' ||
        this.form2.customCompanyWeb === undefined
      ) {
        that.$message.error('请输入您公司的网址')
        return false
      }
      if (this.form2.inTheCity === '' || this.form2.inTheCity === undefined) {
        that.$message.error('请输入您公司的所在城市')
        return false
      }
      if (
        this.form2.customCompanyName === '' ||
        this.form2.customCompanyName === undefined
      ) {
        that.$message.error('请输入您公司的简称')
        return false
      }
      if (
        this.form2.detailedAddress === '' ||
        this.form2.detailedAddress === undefined
      ) {
        that.$message.error('请输入您的公司所在地址')
        return false
      }
      if (this.customCompanyLogo.indexOf('https://images.qilinpin.cn/') < 0) {
        that.$message.error('请上传您的公司Logo')
        return false
      }

      axios({
        method: 'POST',
        url: Config.path + '/api/platform/company/addOne',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
        data: {
          company: this.form2.customCompanyName,
          companyName: this.form2.customCompanyFullName,
          companyAdder: this.form2.detailedAddress.value,
          provinceName: this.form2.detailedAddress.province,
          cityName: this.form2.detailedAddress.city,
          areaName: this.form2.detailedAddress.district,
          cityCode: this.form2.detailedAddress.adcode,
          location: '0,0',
          companyEmail: 'admin@pinkuaikuai.com',
          linkman: '管理员',
          linkmanPhone: '18888888888',
          financingStage: this.form2.financingStage,
          companySize: this.form2.staffSize,
          industry: this.form2.industry,
          industryCode: "2",
          companyLogo: this.customCompanyLogo,
        },
      })
        .then((res) => {
          if (res.data.success === '1') {
            that.getCompanyList()
            that.dialogFormVisible2 = false
          } else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    addzw: function () {
      this.form2 = {
        title: '添加新的客户公司信息',
        customCompanyFullName: '',
        customCompanyWeb: '',
        customCompanyName: '',
        detailedAddress: '',
        inTheCity: '',
        customCompanyNature: this.NatureSelector[0],
        financingStage: this.financingStageSelector[0],
        staffSize: this.companyPeopleNumberSelector[0],
        industry: this.industrySelector[0].value,
      }
      this.file = false
      this.customCompanyLogo = ''
      this.dialogFormVisible2 = true
    },
    changeCompanyName: function () {
      this.pageNumber = 1
      this.getCompanyList()
    },
    onChangeSelectType(e) {
      this.pageSize = 20
      this.pageNumber = 1
      this.selectType = e
      this.getCompanyList()
    },
    showCompanyAudit: function (e) {
      this.activeItem = e
      this.ckMode = true
    },
    hideCompanyAudit: function () {
      this.ckMode = false
    },
    getCompanyList: function () {
      let that = this
      let url = ''
      url = Config.path + '/api/platform/company/getCompanyList'
      let data = {
        status: this.selectTypeArray[this.selectType],
        pageSize: this.pageSize,
        pageNum: this.pageNumber,
      }
      if (this.companyName !== '' && this.companyName !== undefined) {
        data.searchKey = this.companyName
      }
      axios({
        method: 'POST',
        url: url,
        headers: {
          'Content-Type': 'application/json',
          token: localStorage.getItem('token'),
        },
        data: data,
      })
        .then(function (response) {
          // eslint-disable-next-line
          console.log(response)
          if (response.data.success === '1') {
            let demo = response.data.content.list
            that.dataList = demo
            that.pageTotal = response.data.content.total
          } else if (response.data.success === '111111') {
            that.$router.push({
              path: '/login',
            })
          } else {
            that.$message({
              message: response.data.message,
              type: 'warning',
            })
          }
        })
        .catch(function (error) {
          // eslint-disable-next-line
          console.log(error)
        })
    },
    handleCurrentChange: function (val) {
      this.pageNumber = val
      this.getCompanyList()
    },
    setCompanyStatus: function (item, value) {
      let that = this
      let url = ''
      url = Config.path + '/api/platform/company/updateStatus'
      let data = {
        id: item.id,
        status: value,
      }
      if (this.companyName !== '' && this.companyName !== undefined) {
        data.searchKey = this.companyName
      }
      axios({
        method: 'POST',
        url: url,
        headers: {
          'Content-Type': 'application/json',
          token: localStorage.getItem('token'),
        },
        data: data,
      })
        .then(function (response) {
          // eslint-disable-next-line
          console.log(response)
          if (response.data.success === '1') {
            that.getCompanyList()
          } else if (response.data.success === '111111') {
            that.$router.push({
              path: '/login',
            })
          } else {
            that.$message({
              message: response.data.message,
              type: 'warning',
            })
          }
        })
        .catch(function (error) {
          // eslint-disable-next-line
          console.log(error)
        })
    },
    czPassword: function (item) {
      let that = this
      let url = ''
      url = Config.path + '/api/platform/company/resetPassword'
      let data = {
        id: item.id,
      }
      axios({
        method: 'POST',
        url: url,
        headers: {
          'Content-Type': 'application/json',
          token: localStorage.getItem('token'),
        },
        data: data,
      })
        .then(function (response) {
          // eslint-disable-next-line
          console.log(response)
          if (response.data.success === '1') {
            that.$message({
              message: '重置密码成功',
              type: 'success',
            })
          } else if (response.data.success === '111111') {
            that.$router.push({
              path: '/login',
            })
          } else {
            that.$message({
              message: response.data.message,
              type: 'warning',
            })
          }
        })
        .catch(function (error) {
          // eslint-disable-next-line
          console.log(error)
        })
    },
  },
  created: function () {
    this.getCompanyList()
  },
  mounted: function () {
    this.getHyList()
    this.getIp()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.addbtn {
  margin-left: 100px;
}

.itemList {
  margin-top: 20px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;
}

.avatar-uploader .el-upload .el-upload-dragger {
  width: 178px;
  height: 178px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.itemList .itemDiv {
  background-color: #ffffff;
  width: 80%;
  margin: 0 auto 15px auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
  padding: 25px;
  border-radius: 8px;
  min-height: 200px;
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
  position: relative;
}

.itemList .itemDiv .logoBox {
}

.itemList .itemDiv .logoBox img {
  width: 80px;
  height: 80px;
  border-radius: 8px;
}

.itemList .itemDiv .companyInfoBox {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  min-height: 200px;
  margin-left: 30px;
  color: #909399;
}

.itemList .itemDiv .companyAudit {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-height: 200px;
  position: absolute;
  right: 130px;
}

.itemList .itemDiv .companyAudit .imageAction {
}

.itemList .itemDiv .companyAudit .imageAction img {
  height: 160px;
}

.itemList .itemDiv .companyAudit .textAction {
  font-size: 12px;
  color: rgb(123, 123, 123);
  text-align: center;
}

.itemList .itemDiv .actionBox {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  min-height: 200px;
  position: absolute;
  right: 40px;
}

.itemList .itemDiv .actionBox button {
  margin: 0;
}

.imgShadow {
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.imgShadow img {
  width: 500px;
}

.imgShadow > div {
  margin-left: 50px;
}

.imgShadow .textAction {
  color: #ffffff;
  padding: 20px 0;
  text-align: center;
}

.imgShadow .actionBox {
}

.imgShadow .close {
  position: absolute;
  top: 30px;
  right: 30px;
}

.block {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
}
</style>
